import React, { useState, useEffect } from 'react';
import { Group, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
import { showNotification } from '@mantine/notifications';
import { sendRequest } from '../../services/services';

dayjs.extend(duration);

const TimerEvent = () => {
  const navigate = useNavigate();

  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((value) => {
        if (value > 0) {
          return value - 1;
        }
        return value;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    sendRequest(`/cashier/logout`, 'PATCH')
      .then(({ msg }) => {
        if (msg === 'Logout successfully!') {
          showNotification({
            title: <Text weight={500}>{msg}</Text>,
          });
          showNotification({
            title: (
              <Text weight={500}>
                Your last login was 6 hours ago. Please log in again to continue.
              </Text>
            ),
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
          });
        }
      });
    localStorage.setItem('token', '');
    localStorage.setItem('userData', '');
    navigate('/');
  };

  const handleAutoLogout = () => {
    showNotification({
      title: (
        <Text weight={500}>Your last login was 6 hours ago. Please log in again to continue.</Text>
      ),
    });
    handleLogout();

    return () => {};
  };

  useEffect(() => {
    if (seconds <= 0) {
      handleAutoLogout();
    }
  }, [seconds]);

  return (
    <div>
      <Group
        style={{
          visibility: seconds <= 60 ? 'visible' : 'hidden',
        }}
      >
        <Title order={6}>Auto Logout In :</Title>
        <Title order={5} size="sm" px="xs" className="blinkBackground">
          {dayjs.duration(seconds * 1000).format('mm:ss')}
        </Title>
      </Group>
    </div>
  );
};
export default TimerEvent;
